import React from "react";
import { ReactComponent as Dollar } from "icons/dollar.svg";

type Props = {
  selected: boolean;
  title: string;
  value: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const BannerPlan: React.FC<Props> = ({
  selected,
  title,
  value,
  onClick,
}): JSX.Element => {
  return (
    <button
      className={`w-96 h-48 bg-bt-white flex flex-col items-center justify-center border border-bt-green ${
        selected ? "border-4" : "border-1"
      }`}
      onClick={onClick}
    >
      <div className="flex flex-row items-center justify-center">
        <div className="flex flex-col mt-3 mr-2">
          <Dollar width={20} height={20} />
        </div>
        <div className="flex flex-col font-nunito font-normal text-4xl text-black">
          {parseFloat(
            value
              .toString()
              .slice(0, -2)
              .concat(`.${value.toString().slice(-2)}`)
          ).toFixed(2)}
        </div>
      </div>
      <div className="flex flex-row items-center justify-center mt-4">
        <div className="font-nunito font-light text-xl text-black">
          {title === "one_time" ? "one-time payment" : "per month"}
        </div>
      </div>
    </button>
  );
};

export default BannerPlan;
